import {GridRenderEditCellParams} from "@mui/x-data-grid-pro";
import {FormControl, FormHelperText} from "@mui/material";
import {DataGridValidationContext} from "src/components/common/dataGrid/crud/validation/DataGridValidationContext.tsx";
import {ColumnValidationFunction} from "./columnValidation";
import {useEffect} from "react";

import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";

export interface CellEditorWithValidationProps<RowData extends object, V> {
	validationFunc: ColumnValidationFunction<RowData, V>;
	params: GridRenderEditCellParams<RowData, V, V>;
	cellEditor: React.ComponentType<GridRenderEditCellParams>;
}

export const CellEditorWithValidation = <RowData extends object, V>(
	props: CellEditorWithValidationProps<RowData, V>,
) => {
	const { params, validationFunc } = props;
	const { setError } = useContextOrThrow(DataGridValidationContext);
	const { value, field, id : rowId, row } = params;
	const error = validationFunc(value, row);

	useEffect(() => {
		setError(rowId, field, error);
	}, [setError, error, field, rowId]);

	return (
		<FormControl error={error !== undefined} variant={"standard"} tabIndex={0}>
			<props.cellEditor
				{...params}
				aria-describedby={"cell-editor-helper-text"}
				tabIndex={0}
				error={error !== undefined}
			/>
			<FormHelperText id={"cell-editor-helper-text"}>{error ?? ""}</FormHelperText>
		</FormControl>
	);
};
